// 日志管理
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea LogManage">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">

      <!-- 搜索区域 -->
      <div class="searchBox clearfix">
        <el-input
          class="inputName"
          placeholder="请输入操作人姓名"
          v-model="paging.search_str"
          clearable></el-input>
        <el-button class="searchButton" type="primary" @click="getLogList('search')">搜 索</el-button>
      </div>

      <!--操作日志table-->
      <div class="operateLogTable">
        <el-table
          v-loading="loading"
          :data="logList"
          width="100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="操作人姓名">
          </el-table-column>
          <el-table-column
            prop="ip4"
            label="IP">
          </el-table-column>
          <el-table-column
            prop="operator_content"
            label="操作内容">
          </el-table-column>
          <el-table-column
            prop="operator_time"
            label="操作时间">
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="paging" v-if="paging.pageCount > 1">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="paging.page"
          layout="prev, pager, next, jumper"
          :page-count="paging.pageCount">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"
  
  export default {
    name: 'LogManage',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 分页数据  page为当前页，perPage为每页数量 
        paging: {
          page: 1,
          perPage: 10,
          pageCount: '',
          search_str: ''
        },
        // 日志列表
        logList: [],
        loading: false
      }
    },
    mounted(){
      this.getLogList()
    },
    created: function () {
    },
    methods: {
      // 当前页值改变，获取新的第三方应用列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.getLogList()
      },
      // 获取日志列表
      getLogList: async function (search) {
        let vm = this
        if (search) {
          // 搜索日志列表
          vm.paging.page = 1
        }
        let data = {
          page: vm.paging.page,
          perPage: vm.paging.perPage,
          search_str: vm.paging.search_str
        }
        // console.log('data', data)
        vm.loading = true
        let res = await systemApi.getLogList(data)
        vm.loading = false
        if (res.meta.code === 200) {
          this.logList = res.data.list
          this.paging.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听搜索值变化
      "paging.search_str": function(newVal) {
        if (newVal === '') {
          this.getLogList()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.searchBox {
  height: 40px;
  .inputName {
    width: 200px;
    float: left;
  }
  .searchButton {
    margin-left: 30px;
    float: left;
  }
}

.operateLogTable {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/System/LogManage.vue